import TreeCheckboxComponent from "../treeview/tree-checkbox.component";
import ViewBase from "../../views/view-base.view";
import { Button, Dialog, Icons, Intent } from "construct-ui";
import GscmDivisionModel from "../../models/gscm-division/gscm-division.model";

export default function GscmDivisionTreeCheckboxComponent() {

  ViewBase.call(this);

  let isDialogOpen = false;
  let gscmDivList = [];
  let selectedParentCodeList = [];
  let selectedChildCodeList = [];
  let required = false;
  let onChangeCallback = (selectedParents, selectedChildren) => { };
  let onChange = (selectedParents, selectedChildren) => {
    selectedChildCodeList = selectedChildren;
    onChangeCallback(selectedParents, selectedChildren);
  };

  let transformToTreeNodeDataObject = (oriObject, parentCode = null) => {
    const transformedObj = {
      code: oriObject.code,
      name: oriObject.name
    }

    if (parentCode !== null) {
      transformedObj.parentCode = parentCode;
    }

    if (oriObject.subProductHirList?.length > 0) {
      transformedObj.children = oriObject.subProductHirList.map(childItem => transformToTreeNodeDataObject(childItem, transformedObj.code))
    }

    return transformedObj;
  }

  let buildGscmDivList = (rawList = []) => {
    const treeList = [];
    const SELECT_ALL_NODE = {
      code: "",
      name: this.getText("LT00000143", "All"),
    };

    treeList.push(SELECT_ALL_NODE);
    treeList[0].children = rawList.map(item => transformToTreeNodeDataObject(item, SELECT_ALL_NODE.code))

    gscmDivList = treeList;
  }

  let getGscmDivisionList = () => {
    gscmDivList = [];
    GscmDivisionModel.getGscmDivisionHierarchy()
      .then(buildGscmDivList)
      .catch(error => {
        this.handleError(error);
      });
  }

  let renderLabel = (selectedCodes, placeholder) => {
    return (selectedCodes?.length > 0)
      ? selectedChildCodeList.length + ' ' + this.getText("LT00000308", "item(s) selected")
      : placeholder || this.getText("LT00000201", "Please select")
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.required === 'boolean') {
        required = vnode.attrs.required;
      }
      if (vnode.attrs.onChange) {
        onChangeCallback = vnode.attrs.onChange;
      }
      if (vnode.attrs.selectedCodes) {
        selectedParentCodeList = vnode.attrs.selectedCodes;
      }
      getGscmDivisionList();
    },
    onupdate: (vnode) => {
      if (vnode.attrs.selectedCodes) {
        selectedParentCodeList = vnode.attrs.selectedCodes;
      }
    },
    view: (vnode) => {
      return [
        m(Button, {
          align: 'left',
          compact: true,
          class: 'select-list '
            + ((required && (!selectedParentCodeList || selectedParentCodeList.length === 0)) ? 'is-invalid-custom ' : '')
            + ((!selectedParentCodeList || selectedParentCodeList.length === 0) ? 'select-list-placeholder ' : ''),
          fluid: true,
          iconRight: Icons.GRID,
          label: renderLabel(vnode.attrs.selectedCodes, vnode.attrs.placeholder),
          outlined: true,
          onclick: () => isDialogOpen = !isDialogOpen,
        }),
        isDialogOpen &&
        m(Dialog, {
          class: 'cui-dialog-l',
          closeOnOutsideClick: false,
          isOpen: isDialogOpen,
          onClose: () => isDialogOpen = false,
          title: this.getText("LT00000579", "Product"),
          content: m('.container', { style: "height: 480px;" },
            m(TreeCheckboxComponent, {
              data: gscmDivList,
              selectedCodes: selectedParentCodeList,
              isLevel1Expanded: vnode.attrs.isLevel1Expanded === true,
              onChange: onChange,
            })
          ),
          footer: [
            m('.d-flex.justify-content-end',
              m(Button, {
                label: this.getText("LT00000021", "Close"),
                intent: Intent.PRIMARY,
                onclick: () => { isDialogOpen = false },
              })
            )
          ]
        }),
        this.getBaseViews()
      ]
    }
  }
}
